import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

export const useFormGuard = (isDirty: boolean) => {
  const blocker = useBlocker(isDirty);

  useEffect(() => {
    if (!isDirty) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);

  return {
    showModal: blocker.state === 'blocked',
    onDiscard: () => blocker.proceed?.(),
    onContinue: () => blocker.reset?.(),
  };
};
